export const EBedrockModels = {
  CLAUDE_SONNET_4: "us.anthropic.claude-sonnet-4-20250514-v1:0",
  CLAUDE_HAIKU_4_5: "us.anthropic.claude-haiku-4-5-20251001-v1:0",
  CLAUDE_SONNET_4_6: "us.anthropic.claude-sonnet-4-6",
  CLAUDE_OPUS_4_6: "us.anthropic.claude-opus-4-6-v1",
} as const;

export type EBedrockModels =
  (typeof EBedrockModels)[keyof typeof EBedrockModels];
